export const COPIED_TEXT_VISIBLE_DURATION = 3000; // 3 seconds